import React, { useState } from "react";
import { IconButton } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { Pane, Text, CDialog, HFlex } from "shared";
import { useTranslation } from "react-i18next";
import { SPACING, Breakpoint } from "theme";
import { css } from "@emotion/css";
import { useHcp } from "api/hooks/useHCPs";
import { EditHcpForm } from "./EditHcpForm";
import { useHealthCareOrganizations } from "routes/healthCareOrganizations/queries/useHealthCareOrganizations";

const HcpInfo: React.VFC = () => {
  const { t } = useTranslation();
  const { data: hcp } = useHcp();
  const { data: hcos } = useHealthCareOrganizations();
  const [isDialogOpen, setDialogOpen] = useState(false);

  const openDialog = () => setDialogOpen(true);
  const closeDialog = () => setDialogOpen(false);

  if (!hcp) return null;

  // Find the health care organization name by ID
  const hcoName = hcp.health_care_organization_id
    ? hcos?.find(hco => hco.id === hcp.health_care_organization_id)?.name || t`form.none`
    : t`form.none`;

  const details = [
    [t`form.email`, hcp.email],
    [t`form.phone`, hcp.phone_number],
    [t`form.address`, hcp.address],
    [t`form.health_care_organization`, hcoName],
    [t`settings.profile_information.time_zone`, hcp.iana_timezone],
    [t`form.slug`, hcp.slug],
    [t`form.admits_patients`, hcp.admits_patients ? t`buttons.yes` : t`buttons.no`],
  ].filter(([, value]) => value);

  return (
    <>
      <Pane dark>
        <HFlex mb={2} justifyContent="space-between" alignItems="center">
          <Text light>{t("form.health_care_provider_details")}</Text>
          <IconButton onClick={openDialog} size="small" aria-label={t("buttons.edit")}>
            <Edit fontSize="small" />
          </IconButton>
        </HFlex>
        <div className={styles.grid}>
          {details.map(([label, value]) => (
            <React.Fragment key={label}>
              <Text light nowrap>
                {label}
              </Text>
              <Text bold nowrap>
                {value}
              </Text>
            </React.Fragment>
          ))}
        </div>
      </Pane>

      <CDialog maxWidth="sm" fullWidth open={isDialogOpen} onClose={closeDialog}>
        <EditHcpForm hcp={hcp} onSuccess={closeDialog} onCancel={closeDialog} />
      </CDialog>
    </>
  );
};

export default HcpInfo;

const styles = {
  grid: css`
    overflow: auto;
    display: grid;
    grid-auto-rows: 45px;
    align-items: center;
    grid-column-gap: ${SPACING}px;
    @media screen and (max-width: ${Breakpoint.sm - 1}px) {
      grid-template-columns: 1fr;
    }
    @media screen and (min-width: ${Breakpoint.sm}px) {
      grid-template-columns: auto 1fr;
    }
  `,
};
